export var TestPageConfigName;

(function (TestPageConfigName) {
  TestPageConfigName["Generic"] = "TEST_GENERIC_PAGE";
  TestPageConfigName["Person"] = "TEST_PERSON_PAGE";
})(TestPageConfigName || (TestPageConfigName = {}));